import { useState } from 'react';
import classNames from 'classnames';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import {
  languages,
  Languages,
  getClientLang,
} from '@utils/i18n';
import { Link } from '@ui/Link';

import s from './LanguageToggle.sss';

type RouteProps = RouteComponentProps<Record<string, string>, StaticRouterContext>;

type LanguageToggleProps = RouteProps & {
  className?: string,
  pathname: string,
};

export const LanguageToggle = withRouter(
  ({ className, staticContext, pathname }: LanguageToggleProps) => {
    const currentLang = (
      typeof window === 'undefined'
        ? staticContext?.lang
        : getClientLang()
    );
    const [loading, setLoading] = useState(false);

    const handleLanguageChange = async (e: React.MouseEvent<HTMLElement>, lang: string) => {
      e.preventDefault();

      if (loading) {
        return;
      }

      setLoading(true);

      try {
        const formData = new FormData();
        formData.append('language', lang);

        await fetch('/i18n/setlang', {
          method: 'POST',
          body: formData,
        });

      } finally {
        window.location.reload();
      }
    };


    return (
      <div className={classNames(s.root, className)}>
        {languages.map(
          (lang) => (
            lang === currentLang
              ? <div key={lang} className={s.langForm} data-lang={lang.toUpperCase()} />
              : (
                <Link
                  key={lang}
                  href={`${lang === Languages.ru || pathname === '/' ? '' : '/uk'}${pathname}`}
                  className={s.langLink}
                  theme="clean"
                  onClick={(e) => handleLanguageChange(e, lang)}
                >
                  <span className={s.newLang}>{lang.toUpperCase()}</span>
                </Link>
              )
          ),
        )}
      </div>
    );
  },
);
